<div class="admin-wrap">
  <div class="container">
    <div class="row">
      <div class="col">
        <h1>RSVP List</h1>
        <div class="rsvp-list">
          <div class="rsvp-item row" *ngFor="let rsvp of rsvps">
            <div class="col-lg-2">
              <p>
                Attending:
                <span *ngIf="rsvp.attendance === 'yes'" class="attend-status attend-yes">
                &#10003; <!-- Unicode checkmark -->
              </span>
                <span *ngIf="rsvp.attendance !== 'yes'" class="attend-status attend-no">
                &#10007; <!-- Unicode X -->
              </span>
              </p>
              <h2>{{ rsvp.name }}</h2>
            </div>
            <div class="col">
              <p>Guests: {{ rsvp.guestCount }}</p>
              <div *ngIf="rsvp.name || rsvp.otherGuestNames?.length">
                <strong>Guests List:</strong>
                <div class="guests-grid">
                  <div class="guest-cell" *ngIf="rsvp.name">{{ rsvp.name }}</div>
                  <div class="guest-cell" *ngFor="let guest of rsvp.otherGuestNames">{{ guest }}</div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
